import axios, { AxiosError, AxiosResponse } from "axios";
import { NetworkError, UnexpectedError } from "./Errors";

export type Country = {
  id: number;
  text: string;
};
export type CuntriesSearchReponse = Country[];

const URL = "/spirit/countries/";

/**
 * Fetch a list of countries.
 *
 * @returns A list of {@link Country} objects.
 * @throws {NetworkError}
 * @throws {UnexpectedError}
 */
export async function fetchCoutnries(): Promise<CuntriesSearchReponse> {
  let result: AxiosResponse<CuntriesSearchReponse>;

  try {
    result = await axios.get(URL);
  } catch (error) {
    if ((<AxiosError>error).response) {
      const err = <AxiosError>error;
      throw new NetworkError(
        "Error while reportig school not found.",
        err.response?.status
      );
    }
    throw new UnexpectedError(
      `Error while reportig school not found. ${error}`
    );
  }

  return result.data;
}
